import {Component, ChangeDetectionStrategy} from "@angular/core";

@Component({
    selector: "app-logout",
    template: `<div style="margin-top:15px; ">
        <button
            type="button"
            (click)="handleLogout()"
            class="btn btn-danger"
            style="margin: 0 auto; padding-left:50px; padding-right:50px;">
            Logout
        </button>
    </div>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LogoutComponent {
    handleLogout = async () => {
        if (confirm("Are you sure you want to logout?")) {
            window.location.href = "/logout.aspx";
        }
    };
}
